import { Button, Row } from 'react-angle-dashboard-components'
import styled from 'styled-components'

export const SearchSection = styled.section`
  background: #237d83;
  height: 380px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-image: url(greenshapesilo.png);
  background-position: 0% 110%;
  background-size: 100%;
  background-repeat: no-repeat;

  @media (max-width: 576px) {
    & {
      background-position: 0% 105%;
      height: 260px;
    }
  }
`

export const searchBarStyles = {
  bar: {
    height: '3em',
    paddingTop: '1px',
    paddingRight: '1px',
    paddingBottom: '1px'
  }
}

export const SearchButton = styled(Button)`
  width: 100%;
  height: 3.1em;
  margin-top: 0.8em;
  @media (min-width: 768px) {
    width: 100px;
    margin-top: 0;
  }
`

const titleSizes = {
  sm: 1.2,
  md: 2.0,
  lg: 3.4,
  xl: 4.5
}

const mobileTitleSize = {
  sm: 1.3,
  md: 1.7,
  lg: 2,
  xl: 2.5
}

export const Title = styled.h1<{ size?: 'sm' | 'md' | 'lg' | 'xl' }>`
  font-family: Sentinel;
  font-size: ${(props) =>
    props.size && titleSizes[props.size]
      ? titleSizes[props.size] + 'em'
      : '4.5rem'};
  margin-bottom: 2rem;
  color: #fff;

  @media (max-width: 576px) {
    & {
      font-size: ${(props) =>
        props.size && mobileTitleSize[props.size]
          ? mobileTitleSize[props.size] + 'em'
          : '2.5rem'};
    }
  }
`

export const CardRow = styled(Row)`
  min-width: auto;
  & > div {
    margin-bottom: 0.6em;
    flex-basis: auto;
    width: 45%;
  }

  @media (min-width: 992px) {
    & > div {
      width: auto;
    }
  }
`
